import React from 'react';
import getOr from '~/util/getOr';
import css from './Card.scss';

interface Props {
  data: {
    node: {};
  };
}

class GolfCourse extends React.Component<Props> {
  render() {
    const course = getOr(this.props.data, 'node.courses.edges.0.node', {});
    return (
      <div>
        <div className={css.detailTitle}>
          Par {course.par} &middot; {course.yardage} yds
        </div>
        <div>
          {getOr(course, 'holes.edges', []).map(elem => {
            const hole = getOr(elem, 'node', {});

            return (
              <div className={css.detailRow} key={hole.id}>
                <span>Hole {hole.number}</span>
                <span>
                  Par {hole.par}, {hole.yardage} yards
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default GolfCourse;
